// extracted by mini-css-extract-plugin
export default {"breadCrumb":"CardView_breadCrumb__6Z3T6","cardsWrapper":"CardView_cardsWrapper__LT7r5"};